import React from 'react';

const PlusIcon = ({ width, color }: { width: string; color: string }) => (
  <svg width={width} viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.65677 4.01538L2 3.98469"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.81304 6.82842L4.84373 1.17165"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlusIcon;
